(function ($) {

    $.widget('custom.chooser', {

        options: {},
        selected: [],
        save: false,

        _create: function () {
            this.initialize();
            this.options.dialog.hide();
        },

        initialize: function () {
            this.registerInputGroupClickEvent();
            this.registerInputGroupDialogSelectButtonClickEvent();
            //this.registerInputGroupDialogCheckboxClickEvent();
            this.registerInputGroupDialogInputChangeEvent();
            this.updateInputGroup();
        },

        registerInputGroupClickEvent: function () {
            var widget = this;
            widget.element.click(function (event) {
                event.preventDefault();
                widget.createInputGroupDialog();
            });
        },

        createInputGroupDialog: function () {
            var widget = this;
            var windowHeight = window.innerHeight;
            var height = windowHeight - 80;
            widget.options.dialog.dialog({
                buttons: [
                    {
                        text: 'Cancel',
                        click: function () {
                            widget.save = false;
                            widget.options.dialog.dialog('close');
                        }
                    },
                    {
                        text: 'Done',
                        "class": "button-default",
                        click: function () {
                            widget.save = true;
                            widget.options.dialog.dialog('close');
                        }
                    }
                ],
                height: height,
                modal: true
            });
            widget.updateInputGroupDialogCSS();
            widget.updateInputGroupInput(widget);
        },

        updateInputGroupDialogCSS: function () {
            var $instance = this.options.dialog.dialog('instance');
            var $container = $instance.uiDialog;
            $container.css('left', '');
            $container.css('top', '');
            $container.css('width', '');
        },

        registerInputGroupDialogSelectButtonClickEvent: function () {
            var widget = this;
            widget.options.dialog.find('.select-button input').click(function () {
                var $checkbox = $(this);
                var checked = $checkbox.prop('checked');
                widget.options.dialog.find('.chooser-item').each(function () {
                    var $item = $(this);
                    var $input = $item.find('input');
                    if (!$input.is(':disabled')) {
                        $input.prop('checked', checked);
                        widget.options.toggleAll(widget, $(this), checked);
                    }
                });
                widget.updateInputGroup();
            });
        },

        registerInputGroupDialogCheckboxClickEvent: function () {
            var widget = this;
            widget.options.dialog.find('.chooser-item input[type="checkbox"]').click(function () {
                widget.updateInputGroup();
            });
        },

        registerInputGroupDialogInputChangeEvent: function () {
            var widget = this;
            widget.options.dialog.find('.chooser-item input').change(function (event) {
                widget.updateInputGroup(event);
            });
        },

        updateInputGroup: function (event) {
            var input = this.options.updateInputGroupInput(this, event);
            this.element.find('.input-group-input input').val(input);
            var text = this.options.updateInputGroupText(this, event);
            if (text != '') {
                this.element.find('.input-group-text').text(text);
            } else {
                var placeholder = this.element.attr('placeholder');
                this.element.find('.input-group-text').text(placeholder);
            }
        },

        updateInputGroupInput: function (widget, event = undefined) {
            // defined when registering the widget....
        },

        toggleAll: function (widget, input, value) {
            // defined when registering the widget....
        },

        updateInputGroupText: function (widget, event = undefined) {
            // defined when registering the widget...
        },

        addSelected: function (element, initial = false) {
            element.initial = initial;
            this.selected.push(element);
        },

        clearSelected: function () {
            this.selected = [];
        },

        hasElement: function (element) {
            let i;
            for (i = 0; i < this.selected.length; i++) {
                if (element.id === this.selected[i].id) {
                    return true;
                }
            }
            return false;
        },

        findById: function (id) {
            let i;
            for (i = 0; i < this.selected.length; i++) {
                if (id === this.selected[i].id) {
                    return i;
                }
            }
            return -1;
        },

        toggleSelected: function (element) {
            if (this.hasElement(element)) {
                this.removeSelected(element);
            } else {
                this.addSelected(element);
            }
        },

        getSelected: function () {
            return this.selected;
        },

        shouldSave: function () {
            return this.save;
        },

        removeSelected: function ($element) {
            for (i = this.selected.length - 1; i >= 0; i--) {
                if (this.selected[i].id == $element.id) {
                    this.selected.splice(i, 1);
                }
            }
        }

    });

})(jQuery);
